export default "__VITE_ASSET__b7b91251__"